import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { TRIAL_DURATION_DAYS, MIDPOINT_THRESHOLD_DAYS, TOUCH_POINT_CONFIG_FLAG, } from "../shared/constants.js";
const TOUCH_POINT_START = {
    step: 1,
    titleKey: "reverse_trial_start_title",
    bodyKeys: [{ key: "reverse_trial_start_body", style: "paragraph" }],
    hasTarget: false,
    minElapsedDays: 0,
    learnMore: "reverse_trial_learn_more",
    autoDismissMs: 10000,
    showOnce: true,
    showFeedback: true,
};
const TOUCH_POINT_MIDPOINT = {
    step: 2,
    titleKey: "reverse_trial_midpoint_title",
    bodyKeys: [
        { key: "reverse_trial_midpoint_body_1", style: "paragraph" },
        { key: "reverse_trial_midpoint_body_2", style: "paragraph" },
    ],
    buttonKey: "reverse_trial_midpoint_premium_button",
    hasTarget: true,
    minElapsedDays: MIDPOINT_THRESHOLD_DAYS,
    showDismissLink: false,
    optOutKey: "reverse_trial_midpoint_opt_out",
    showOnce: true,
    showFeedback: true,
};
const TOUCH_POINT_ENDED = {
    step: 3,
    titleKey: "reverse_trial_ended_title",
    bodyKeys: [
        { key: "reverse_trial_ended_body_1", style: "paragraph" },
        { key: "reverse_trial_ended_body_2", style: "paragraph" },
    ],
    buttonKey: "reverse_trial_ended_premium_button",
    hasTarget: true,
    minElapsedDays: TRIAL_DURATION_DAYS,
    showFeedback: true,
};
const TOUCH_POINTS = [
    TOUCH_POINT_START,
    TOUCH_POINT_MIDPOINT,
    TOUCH_POINT_ENDED,
];
export const LAST_TOUCH_POINT_STEP = TOUCH_POINTS[TOUCH_POINTS.length - 1].step;
async function getExperimentConfigOverride(step) {
    const flagValue = await ewe.experiments.getFlag(TOUCH_POINT_CONFIG_FLAG);
    if (typeof flagValue !== "object" || flagValue === null) {
        return undefined;
    }
    const stepValue = flagValue[String(step)];
    if (typeof stepValue !== "object" || stepValue === null) {
        return undefined;
    }
    const stepOverride = {};
    if ("autoDismissMs" in stepValue) {
        if (typeof stepValue.autoDismissMs === "number" ||
            stepValue.autoDismissMs === null) {
            stepOverride.autoDismissMs = stepValue.autoDismissMs;
        }
    }
    if ("showFeedback" in stepValue) {
        if (typeof stepValue.showFeedback === "boolean" ||
            stepValue.showFeedback === null) {
            stepOverride.showFeedback = stepValue.showFeedback;
        }
    }
    if ("showDismissLink" in stepValue) {
        if (typeof stepValue.showDismissLink === "boolean" ||
            stepValue.showDismissLink === null) {
            stepOverride.showDismissLink = stepValue.showDismissLink;
        }
    }
    return stepOverride;
}
async function withConfigOverride(config) {
    const stepOverride = await getExperimentConfigOverride(config.step);
    if (!stepOverride) {
        return config;
    }
    const result = { ...config };
    if (typeof stepOverride.autoDismissMs === "number") {
        result.autoDismissMs = stepOverride.autoDismissMs;
    }
    else if (stepOverride.autoDismissMs === null) {
        delete result.autoDismissMs;
    }
    if (typeof stepOverride.showFeedback === "boolean") {
        result.showFeedback = stepOverride.showFeedback;
    }
    else if (stepOverride.showFeedback === null) {
        delete result.showFeedback;
    }
    if (typeof stepOverride.showDismissLink === "boolean") {
        result.showDismissLink = stepOverride.showDismissLink;
    }
    else if (stepOverride.showDismissLink === null) {
        delete result.showDismissLink;
    }
    return result;
}
export async function resolveNextTouchPoint(lastShownStep, elapsedDays) {
    const config = TOUCH_POINTS.slice()
        .reverse()
        .find((config) => lastShownStep < config.step && elapsedDays >= config.minElapsedDays);
    if (!config) {
        return undefined;
    }
    return await withConfigOverride(config);
}
export async function getTouchPoint(step) {
    const config = TOUCH_POINTS.find((config) => config.step === step);
    if (!config) {
        return undefined;
    }
    return await withConfigOverride(config);
}
